import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Close",
  "use": "Close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"Close\">\n\t<path d=\"M30 4.8L27.2 2 16 13.2 4.8 2 2 4.8 13.2 16 2 27.2 4.8 30 16 18.8 27.2 30l2.8-2.8L18.8 16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol